import React, { useState, useEffect } from 'react';
import DataTableDocumentActionModal from 'components/DataTableDocumentActionModal';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import FormField from 'layouts/applications/wizard/components/FormField';
import Swal from 'sweetalert2';
import axios from 'axios';

const AgentModal = ({ show, handleClose, getData, document, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        nombre: '',
        pais: '',
        direccion: '',
    });

    useEffect(() => {
        if (document) {
            setFormData({
                nombre: document.nombre || '',
                pais: document.pais || '',
                direccion: document.direccion || '',
            });
        } else {
            setFormData({
                nombre: '',
                pais: '',
                direccion: '',
            });
        }
    }, [document]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const url = document
                ? `${process.env.REACT_APP_SERVER_URL}/api/maintenance/agent/${document.id_agente}/`
                : `${process.env.REACT_APP_SERVER_URL}/api/maintenance/agents/`;

            const response = document
                ? await axios.put(url, formData)
                : await axios.post(url, formData);

            getData();
            Swal.fire({
                icon: 'success',
                title: document ? 'Agente Actualizado' : 'Agente Creado',
                text: `El agente ha sido ${document ? 'actualizado' : 'creado'} exitosamente`,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Ocurrió un error al ${document ? 'actualizar' : 'crear'} el agente`,
            });
        } finally {
            handleClose();
            onClose && onClose();
            setIsLoading(false);
        }
    };

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e?.target?.value });
    };

    return (
        <DataTableDocumentActionModal
            show={show}
            handleClose={() => {
                handleClose();
                onClose && onClose();
            }}
            title={document ? "Editar Agente" : "Nuevo Agente"}
            handleSubmit={handleSubmit}
            isSubmitting={isLoading}
            submitText={document ? "Actualizar" : "Crear"}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        label="Nombre del Agente"
                        value={formData.nombre}
                        onChange={handleChange('nombre')}
                        placeholder="Ingrese el nombre del agente"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        label="País"
                        value={formData.pais}
                        onChange={handleChange('pais')}
                        placeholder="Ingrese el país del agente"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        label="Dirección"
                        value={formData.direccion}
                        onChange={handleChange('direccion')}
                        placeholder="Ingrese la dirección del agente"
                    />
                </Grid>
            </Grid>
        </DataTableDocumentActionModal>
    );
};

AgentModal.propTypes = {
    show: PropTypes.bool,
    getData: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    document: PropTypes.shape({
        id_agente: PropTypes.number,
        nombre: PropTypes.string,
        pais: PropTypes.string,
        direccion: PropTypes.string,
    }),
    onClose: PropTypes.func,
};

export default AgentModal;